/** @jsx jsx */
import { css, keyframes } from '@emotion/react';
import { B75, B300 } from '@atlaskit/theme/colors';
var flashTime = 700;
export var flashAnimation = keyframes({
  '0%': {
    backgroundColor: 'transparent'
  },
  '20%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  },
  '75%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  },
  '100%': {
    backgroundColor: "var(--ds-background-selected-pressed, ".concat(B75, ")"),
    borderColor: "var(--ds-border-selected, ".concat(B300, ")")
  }
});
export var containerStyle = css({
  width: '100%',
  height: '100%'
});
export var flashStyle = css({
  animation: "".concat(flashAnimation, " ").concat(flashTime, "ms ease-in-out")
});